import request from './request'

export function regCustomer(Customer) {
  return request({
    url: '/api/Curtain/RegCustomer',
    method: 'post',
    data:Customer
})
}


// WEBPACK FOOTER //
// ./src/api/RegCustomer.js